import React from 'react';
import { H5 } from '../../../../AbstractElements';
import { FormGroup, Input, Label, FormFeedback, Row, Col } from 'reactstrap';

const AddressInfoForm = ({ formData, errors, handleInputChange, cities, filteredDistricts, handleCityChange, fieldPermissions, canEdit = true }) => {
      // Helper function to check field access based on permissions
    const getFieldAccess = (fieldName) => {
        // If canEdit is false, all fields should be disabled regardless of permissions
        if (!canEdit) {
            return {
                disabled: true,
                required: false,
            };
        }
        
        // Ensure fieldPermissions is an array before calling .find()
        const safeFieldPermissions = Array.isArray(fieldPermissions) ? fieldPermissions : [];
        const permission = safeFieldPermissions.find(p => p.fieldName.toLowerCase() === fieldName.toLowerCase());
        // Default to editable and not required if no specific permission is found
        return {
            disabled: permission ? !permission.editable : false,
            required: permission ? permission.required : false,
        };
    };

    // Define field access based on API field names (verify these names!)
    const cityAccess = getFieldAccess('customer.district.city'); // Assuming API uses 'customer.district.city' or similar for city
    const districtAccess = getFieldAccess('customer.district'); // Assuming API uses 'customer.district' for district
    const addressAccess = getFieldAccess('customer.address');

    // İlçe seçimini özel olarak işle, sadece district ID'sini kaydet
    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        
        // API'ye gönderilecek verinin formatı: district değeri direkt ID olmalı, boş seçim için null
        handleInputChange({
            target: {
                name: 'district',
                value: districtId === "" ? null : districtId
            }
        });
    };
    
    return (
        <>
            <H5>Adres Bilgileri</H5>
            <div style={{ height: "20px" }}></div>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label for="city">Şehir {cityAccess.required && <span className="text-danger">*</span>}</Label>
                        <Input
                            type="select"
                            id="city"
                            name="city"
                            value={formData.city || ''}
                            onChange={(e) => handleCityChange(e.target.value)}
                            className={errors.city ? 'is-invalid' : ''}
                            disabled={cityAccess.disabled}
                            required={cityAccess.required}
                        >
                            <option value="">Seçiniz</option>
                            {cities && cities.length > 0 ? 
                                cities.map(city => (
                                    <option key={city.id} value={city.id}>
                                        {city.title}
                                    </option>
                                )) : 
                                <option value="" disabled>Şehir bulunamadı</option>
                            }
                        </Input>
                        <FormFeedback>{errors.city}</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="district">İlçe {districtAccess.required && <span className="text-danger">*</span>}</Label>
                        <Input
                            type="select"
                            id="district"
                            name="district"
                            value={formData.district || ''}
                            onChange={handleDistrictChange}
                            disabled={!formData.city || districtAccess.disabled}
                            required={districtAccess.required}
                            className={errors.district ? 'is-invalid' : ''}
                        >
                            <option value="">Seçiniz</option>
                            {filteredDistricts && filteredDistricts.length > 0 ? 
                                filteredDistricts.map(district => (
                                    <option key={district.id} value={district.id}>
                                        {district.title}
                                    </option>
                                )) : 
                                <option value="" disabled>{formData.city ? 'İlçe bulunamadı' : 'Önce şehir seçiniz'}</option>
                            }
                        </Input>
                        <FormFeedback>{errors.district}</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <FormGroup>
                <Label for="address">Adres {addressAccess.required && <span className="text-danger">*</span>}</Label>
                <Input
                    type="textarea"
                    id="address"
                    name="address"
                    value={formData.address || ''}
                    onChange={handleInputChange}
                    rows={3}
                    invalid={!!errors.address}
                    disabled={addressAccess.disabled}
                    required={addressAccess.required}
                />
                <FormFeedback>{errors.address}</FormFeedback>
            </FormGroup>
        </>
    );
};

export default AddressInfoForm;
